<template>
  <section class="containerOpportunity">
    <section class="containerOpportunity__content">
      <div class="containerOpportunity__content--back">
        <div class="contentBack" @click="goBackHandler">
          <span class="grey-icon-arrow-back contentBack__icon"></span>
          <span class="contentBack__label bookFont">Back</span>
        </div>
      </div>
      <notSupportedMobile v-show="isMobileResolution" message="This device does not allow uploading."></notSupportedMobile>
      <skeletonOpportunityForm v-if="!loadPage && !isMobileResolution" />
      <section v-show="!isMobileResolution" v-if="loadPage" class="containerOpportunity__content--form">
        <span class="form__title">{{isAnEdition ? 'Edit' : 'New'}} Opportunity</span>
        <section class="form__body">
          <form class="form__body--main" @change="changeHandler">
            <inputListMultipleValues
              label="CLIENTS"
              placeholder="Start typing..."
              v-model:modelValue="formFields.clients"
              :options="store.state.opportunities.metadata.clients"
              :showErrors="store.state.opportunities.showErrors"
              :showLabelFunc="(option) => option"
              idProperty="id">
            </inputListMultipleValues>
            <inputListMultipleValues
              v-if="isOtherClient(formFields.clients)"
              label="OTHER"
              placeholder="Start typing..."
              v-model:modelValue="formFields.otherClients"
              :options="store.state.opportunities.metadata.potentialClients"
              :showErrors="store.state.opportunities.showErrors"
              :showLabelFunc="(option) => option"
              idProperty="id"
              allowUserValues
              :charactersMaxLength="50"
              @update:modelValue="checkClientValue"
              :invalidItems="invalidClients"
              errorType="client"
              caseInsensitive>
            </inputListMultipleValues>
            <inputGeneric
              label="PROJECT"
              :maxLength="50"
              v-model="formFields.project"
              placeholder="Start typing..."
              :showErrors="store.state.opportunities.showErrors"
              required>
            </inputGeneric>
            <inputGeneric
              label="ROLE"
              :maxLength="80"
              v-model="formFields.role"
              placeholder="Start typing..."
              :showErrors="store.state.opportunities.showErrors || draftError"
              required
              id="form_opportunity">
            </inputGeneric>
            <div class="mainForm__positionDateFields">
              <inputDatePicker
                label="POSITION DATE"
                v-model="formFields.positionDate"
                :showErrors="store.state.opportunities.showErrors"
                @update:modelValue="changeHandler()"
                required>
              </inputDatePicker>
              <inputPercentage
                ref="inputNumberRef"
                required
                v-model="formFields.percentage"
                :showErrors="store.state.opportunities.showErrors"
                id="form_number">
              </inputPercentage>
            </div>
            <inputListMultipleValues
              label="ROLE NEEDED"
              placeholder="Start typing..."
              v-model:modelValue="formFields.roleNeeded"
              :options="store.state.opportunities.metadata.roles"
              :showErrors="store.state.opportunities.showErrors"
              :showLabelFunc="(option) => option"
              idProperty="id">
            </inputListMultipleValues>
            <htmlInput
              label="ROLE DESCRIPTION"
              ref="htmlInputRef"
              v-model="formFields.description"
              @update:modelValue="changeHandler"
              :roleDescriptionPlaceholder="store.state.opportunities.metadata.roleDescriptionPlaceholder"
              :showErrors="store.state.opportunities.showErrors"
              required>
            </htmlInput>
            <inputListMultipleValues
              label="CONTACTS"
              v-model:modelValue="formFields.primaryContacts"
              :getAsyncOptions="searchPeople"
              :showLabelFunc="(option) => ({ value: `${option.name} (${option.email})`, id: option.email, name: option.name })"
              idProperty="email"
              :showArrowDropDown="false"
              :showErrors="store.state.opportunities.showErrors"
              :arrayMaxLength="10"
              :invalidItems="invalidUsers"
              id="form_contacts"
              required>
            </inputListMultipleValues>
            <inputListMultipleValues
              label="CAPABILITIES"
              v-model:modelValue="formFields.capabilities"
              :options="store.state.opportunities.metadata.capabilities"
              :showLabelFunc="(option) => option"
              :showErrors="store.state.opportunities.showErrors"
              idProperty="id"
              allowUserValues
              required
              :charactersMaxLength="80">
            </inputListMultipleValues>
            <inputList
              label="AUTHOR"
              v-model:modelValue="formFields.author"
              :getAsyncOptions="searchPeople"
              :showArrowDropDown="false"
              :showErrors="store.state.opportunities.showErrors"
              required
              disabled>
            </inputList>
          </form>
          <section class="form__body--secondary">
            <section class="publishContainer">
              <div class="publishContainer__header">
                <span class="publishContainer__header--title">PUBLISH</span>
              </div>
              <div class="publishContainer__body">
                <div class="publishContainer__body--field">
                  <span class="label">Status:</span>
                  <span class="statusValue">{{formFields.status}}</span>
                </div>
                <div class="publishContainer__body--field">
                  <span class="label required">Publish Date</span>
                  <datePicker
                    v-model="formFields.startDate"
                    @update:modelValue="changeHandler()"
                    :showErrors="store.state.opportunities.showErrors">
                  </datePicker>
                </div>
                <div class="publishContainer__body--field">
                  <span class="label">End Date</span>
                  <datePicker
                    v-model="formFields.endDate"
                    :lowerLimit="dateLowerLimit"
                    @update:modelValue="changeHandler(true)"
                    :showErrors="store.state.opportunities.showErrors"
                    :forceError="endDateError"
                    dateClearable>
                  </datePicker>
                </div>
              </div>
              <div class="publishContainer__footer">
                <button class="publishContainer__footer--draftButton" v-if="showSaveAsDraft" :class="{'withSpinner': showDraftSpinner}" @click="saveAsDraft">
                  <spinner class="draftSpinner" v-if="showDraftSpinner"/>
                  Save as Draft
                </button>
                <button class="publishContainer__footer--button" @click="publish" :class="{'withSpinner': showSpinner}">
                  <spinner :class="[ !isScheduledDate ? 'publishSpinner' : 'scheduleSpinner']" v-if="showSpinner"/>
                  {{ showSaveAsDraft ? (isScheduledDate ? 'Schedule' : 'Publish') : 'Update'}}
                </button>
              </div>
            </section>
            <section class="uploadContainer">
              <div class="uploadContainer__header">
                <span class="uploadContainer__header--title">CLIENT LOGO</span>
              </div>
              <imageUploader
                :showErrors="store.state.showErrors"
                @touchedFile="changeHandler()">
              </imageUploader>
            </section>
          </section>
        </section>
      </section>
      <confirmationModal
        class="exitFormModal"
        ref="exitModalRef"
        title="Exit Editing"
        message="If you leave now you will lose everything."
        boldMessage="Do you still want to leave?"
        confirmText="YES"
        cancelText="CANCEL"
        @confirmAction="goBack(true)">
      </confirmationModal>
      <successModal
        ref="successModalRef"
        @close="goBack"
        :message="modalMessage.title"
        :additionalMessage="modalMessage.text"
        :icon="modalMessage.icon"
        :class="modalMessage.name">
      </successModal>
    </section>
    <transition name="toast">
      <toastMessage v-if="store.state.toastMessage.visible"/>
    </transition>
  </section>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import formConfig from './opportunityForm.json'
import inputGeneric from '@/components/form/inputGeneric/inputGeneric'
import confirmationModal from '@/components/confirmationModal/confirmationModal'
import htmlInput from '@/components/form/htmlInput/htmlInput'
import datePicker from '@/components/form/datePicker/datePicker'
import successModal from '@/components/successModal/successModal'
import toastMessage from '@/components/toastMessage/toastMessage'
import notSupportedMobile from '@/components/notSupportedMobile/notSupportedMobile'
import spinner from '@/components/spinner/spinner'
import moment from 'moment'
import inputList from '@/components/form/inputList/inputList'
import inputListMultipleValues from '@/components/form/inputListMultipleValues/inputListMultipleValues'
import imageUploader from '@/components/form/imageUploader/imageUploader'
import inputDatePicker from '@/components/form/inputDatePicker/inputDatePicker'
import inputPercentage from '@/components/form/inputPercentage/inputPercentage'
import skeletonOpportunityForm from '@/components/opportunities/skeletonOpportunityForm/skeletonOpportunityForm'
import { openConnectionWs, startConnection } from '@/utils/webSocket'

export default {
  name: 'opportunity',
  components: {
    inputGeneric,
    confirmationModal,
    htmlInput,
    datePicker,
    successModal,
    toastMessage,
    notSupportedMobile,
    spinner,
    inputList,
    inputListMultipleValues,
    imageUploader,
    inputDatePicker,
    inputPercentage,
    skeletonOpportunityForm
  },
  setup (props) {
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    const isFormTouched = ref(false)
    const exitModalRef = ref(null)
    const successModalRef = ref(null)
    const isMobileResolution = ref(false)
    const loadPage = ref(false)
    const formFields = ref(JSON.parse(JSON.stringify(formConfig.formData)))
    const showSpinner = ref(false)
    const htmlInputRef = ref(null)
    const endDateError = ref(false)
    const webSocketConnection = ref(null)
    const modalMessage = ref(JSON.parse(JSON.stringify(formConfig.modalMessages.published)))
    const showDraftSpinner = ref(false)
    const draftError = ref(false)
    const invalidUsers = ref([])
    const invalidClients = ref([])
    const inputNumberRef = ref(null)

    /**
     * @description Sets end date lower limit
     */
    const dateLowerLimit = computed(() => {
      const currentDate = moment(new Date()).format('YYYY-MM-DD')
      const startDate = formFields.value.startDate ? moment(formFields.value.startDate, 'YYYY-MM-DD') : moment(currentDate, 'YYYY-MM-DD')
      return (startDate.diff(currentDate, 'days')) <= 0 ? new Date(store.getters.addDaysToDate(1, new Date())) : new Date(store.getters.addDaysToDate(1, formFields.value.startDate))
    })

    /**
     * @description Checks if the current form is an edition
     */
    const isAnEdition = computed(() => {
      return route.params.opportunityId
    })

    /**
     * @description Checks if publish date selected is valid
     */
    const isAValidDate = computed(() => {
      const currentDate = moment(new Date()).format('YYYY-MM-DD')
      const startDate = formFields.value.startDate ? moment(formFields.value.startDate, 'YYYY-MM-DD') : moment(currentDate, 'YYYY-MM-DD')
      const endDate = !formFields.value.endDate ? null : moment(formFields.value.endDate, 'YYYY-MM-DD')
      return !endDate || ((endDate.diff(startDate, 'days')) >= 1 && (endDate.diff(currentDate, 'days')) >= 0)
    })

    /**
     * @description Checks if form has all required fields completed
     */
    const isFormComplete = computed(() => {
      return formFields.value.project.trim() && formFields.value.role.trim() && formFields.value.description && htmlInputRef.value.wordCounter && formFields.value.primaryContacts.length &&
      formFields.value.capabilities.length && formFields.value.author && formFields.value.positionDate.length && formFields.value.percentage
    })

    /**
     * @description Returns if other client was selected
     * @param clients The list of clients to check
     */
    const isOtherClient = computed(() => (clients) => {
      return clients.find(client => client.value === 'Other')
    })

    /**
     * @description Checks if publish date is in the future (based on EST time)
     */
    const isScheduledDate = computed(() => {
      return store.getters['opportunities/getTimeDiference'](formFields.value.startDate, 'minutes') > 0
    })

    /**
     * @description Validate if display save as draft button
     */
    const showSaveAsDraft = computed(() => {
      return ['new', 'draft', 'closed'].includes(formFields.value.status.toLowerCase())
    })

    onMounted(() => {
      resizeSetUp()
      handleResize()
      setInitialData()
    })

    /**
     * @description Determines if user can go back or if a modal should be shown.
     */
    function goBackHandler () {
      if (isFormTouched.value) {
        exitModalRef.value.open()
      } else {
        goBack(true)
      }
    }

    /**
     * @description Go to go grey home page
     * @param backButton Flag to know if back button was clicked
     */
    function goBack (backButton = false) {
      manageBeforeUnloadListener(false)
      goToResultsOpportunities(backButton)
    }

    /**
     * @description Go to opportunities admin
     * @param backButton Flag to know if back button was clicked
     */
    function goToResultsOpportunities (backButton = false) {
      if (isAnEdition.value && backButton) {
        window.open(document.referrer, '_self')
      } else {
        const routeData = router.resolve({ name: 'resultsOpportunities', query: { tb: 'mine', q: '', t: 24, k: 1, f: '' } })
        window.open(routeData.href, '_self')
      }
    }

    /**
     * @description Checks the size of the screen
     */
    function handleResize () {
      window.addEventListener('resize', function (e) {
        resizeSetUp()
      })
    }

    /**
     * @description Checks if screen has mobile resolution
     */
    function resizeSetUp () {
      isMobileResolution.value = window.innerWidth <= 1024
    }

    /**
     * @description Gets and set the initial data to display in the form
     */
    function setInitialData () {
      const promisesToResolveBeforeEnter = [store.dispatch({ type: 'opportunities/getOpportunityMetadata' })]
      if (isAnEdition.value) promisesToResolveBeforeEnter.push(store.dispatch({ type: 'opportunities/getEditOpportunity', id: route.params.opportunityId }))

      Promise.all(promisesToResolveBeforeEnter).then(responses => {
        if (isAnEdition.value && !responses[1].success) {
          const routeData = router.resolve({ name: 'emptyState' })
          window.open(routeData.href, '_self')
        } else {
          store.commit({
            type: 'opportunities/SET_OPPORTUNITY_METADATA',
            metadata: formatMetadata(responses[0])
          })
          if (isAnEdition.value) {
            store.commit({
              type: 'opportunities/SET_OPPORTUNITY_ITEM',
              opportunity: formatOpportunity(responses[1])
            })
            store.commit({
              type: 'opportunities/SET_IMAGE_ID',
              id: responses[1].imageId
            })
            store.commit({
              type: 'opportunities/UPDATE_UPLOAD_LOGO_INFO',
              info: { status: 'uploaded' }
            })
            formFields.value = store.state.opportunities.opportunityItem
            if (store.state.opportunities.opportunityItem.isLocked && !store.state.opportunities.opportunityItem.lockedByMe && !store.state.opportunities.opportunityItem.takenOver) {
              displaySuccessModal('cantAccess')
            } else {
              setUpWebSocket()
            }
          } else {
            formFields.value.author = store.state.opportunities.metadata.defaultValues.author
            formFields.value.startDate = moment(new Date()).format('YYYY-MM-DD')
          }
          loadPage.value = true
        }
      })
    }

    /**
     * @description Manages to set the form as touched.
     * @param isEndDate Flag to know if field updated is the end date
     */
    function changeHandler (isEndDate = false) {
      if (!isFormTouched.value) {
        manageBeforeUnloadListener(false)
        manageBeforeUnloadListener()
        isFormTouched.value = true
      }
      if (isEndDate) endDateError.value = false
    }

    /**
     * @description Display success modal
     * @param type the type of modal to show
     */
    function displaySuccessModal (type) {
      modalMessage.value = formConfig.modalMessages[type]
      if (type === 'scheduled') {
        modalMessage.value.text = modalMessage.value.text.replace('${}', moment(formFields.value.startDate).format('MMM D YYYY'))
      }
      successModalRef.value.open()
    }

    /**
     * @description Validate if opportunity can be published
     * @param isDraftValidation Flag to know if is validating a draft
     */
    function prePublishValidation (isDraftValidation) {
      if (!isDraftValidation) setShowErrors()

      if (isDraftValidation ? !formFields.value.role : !isFormComplete.value) {
        if (isDraftValidation) {
          setShowErrors(false)
          draftError.value = true
          document.getElementById('form_opportunity').focus()
        }
        displayToastMessage('publishValidation')
        return false
      }

      if (!isAValidDate.value && !isDraftValidation) {
        endDateError.value = true
        displayToastMessage('invalidDate')
        return false
      }

      if (isOtherClient.value(formFields.value.clients) && invalidClients.value.length) {
        displayToastMessage('clientExists')
        return false
      }

      if (inputNumberRef.value.error) {
        document.getElementById('form_number').focus()
        return false
      }

      if (store.state.opportunities.fileInfo.status === 'uploading') {
        displayToastMessage('fileUploading')
        return false
      }

      return true
    }

    /**
     * @description Calls service to publish opportunity
     */
    function publish () {
      if (prePublishValidation()) {
        showSpinner.value = true
        validateContacts().then(() => {
          if (!formFields.value.startDate) formFields.value.startDate = moment(new Date()).format('YYYY-MM-DD')
          const serviceToCall = isAnEdition.value || formFields.value.status === 'Draft' ? 'editOpportunity' : 'newOpportunity'
          store.dispatch({
            type: `opportunities/${serviceToCall}`,
            data: generateOpportunityBody()
          }).then(response => {
            showSpinner.value = false
            if (response.success) displaySuccessModal(showSaveAsDraft.value ? (isScheduledDate.value ? 'scheduled' : 'published') : 'updated')
            else displayToastMessage('requestError')
          }).catch(() => {
            showSpinner.value = false
            displayToastMessage('requestError')
          })
        })
      }
    }

    /**
     * @description Generates the data object to send to publish service
     */
    function generateOpportunityBody () {
      const { value: valueAuthor, ...author } = formFields.value.author
      const contacts = formFields.value.primaryContacts.map(({ eccode, ecCode, name, email }) => ({ eccode: eccode || ecCode, name, email }))
      const potentialClients = isOtherClient.value(formFields.value.clients) && formFields.value.otherClients.length ? formFields.value.otherClients.map(data => data.id) : []
      const body = {
        ...((isAnEdition.value || formFields.value.status === 'Draft') && { id: store.state.opportunities.opportunityItem.id }),
        role: formFields.value.role,
        agency: '',
        clients: formFields.value.clients.map(data => data.value),
        potentialClients: potentialClients,
        project: formFields.value.project,
        description: formFields.value.description,
        numberOfHours: Number(formFields.value.percentage),
        positionStartDate: formFields.value.positionDate[0] || null,
        positionEndDate: formFields.value.positionDate[1] || null,
        capabilities: formFields.value.capabilities.map(data => data.value),
        primaryContacts: contacts,
        author,
        startDate: formFields.value.startDate,
        endDate: formFields.value.endDate,
        imageId: store.state.opportunities.imageId,
        roleNeeded: formFields.value.roleNeeded.map(data => data.value)
      }
      return body
    }

    /**
     * @description Set show errors
     * @param showErrors boolean flag
     */
    function setShowErrors (showErrors = true) {
      store.commit({
        type: 'opportunities/SET_OPPORTUNITY_FORM_ERRORS',
        showErrors: showErrors
      })
    }

    /**
     * @description Adds/Removes listener for beforeunload event.
     * @param addEvent Flag to know if listener should be added or removed.
     */
    function manageBeforeUnloadListener (addEvent = true) {
      window[addEvent ? 'addEventListener' : 'removeEventListener']('beforeunload', listenerChangePage)
    }

    /**
     * @description Listens when the users wants to change the page and shows a prevent modal.
     * @param {event} event fired by the user.
     */
    function listenerChangePage (event) {
      event.preventDefault()
      event.returnValue = ''
    }

    /**
     * @description show toast message during 5 seconds
     * @param type type of toast
     * @param error error code
     */
    function displayToastMessage (type, error = '') {
      store.commit({
        type: 'SET_TOAST_MESSAGE',
        toastMessage: { visible: true, type: type, error: error }
      })
      setTimeout(() => {
        resetToastMessage()
      }, 5000)
    }

    /**
     * @description reset toast message
     */
    function resetToastMessage () {
      store.commit({
        type: 'SET_TOAST_MESSAGE',
        toastMessage: { visible: false, type: '', error: '' }
      })
    }

    /**
     * @description Searches users based on search term.
     * @param searchTerm Term to search collaborators.
     */
    function searchPeople (searchTerm) {
      return store.dispatch({
        type: 'opportunities/searchUser',
        searchTerm: searchTerm
      })
    }

    /**
     * @description Format user object
     * @param name name of user
     * @param email email of user
     * @param ecCoce ecCoce of user
     * @param eccode eccode of user
     */
    function userFormField ({ name, email, ecCode, eccode }) {
      return {
        name,
        email,
        ecCode: ecCode || eccode,
        value: `${name} (${email})`
      }
    }

    /**
     * @description Format metatada fields
     * @param metadata the metadata objetc
     */
    function formatMetadata (metadata) {
      const fieldsToMap = ['clients', 'capabilities', 'potentialClients', 'roles']
      fieldsToMap.forEach((field) => {
        if (metadata[field] && metadata[field].length) {
          metadata[field] = metadata[field].map((data) => {
            return {
              value: field === 'potentialClients' ? `${data} (Potential client)` : data,
              id: data
            }
          })
        }
      })
      metadata.defaultValues.author = userFormField(metadata.defaultValues.author)
      return metadata
    }

    /**
     * @description Format opportunity fields to fill the form
     * @param opportunity the opportunity data
     */
    function formatOpportunity (opportunity) {
      opportunity.clients = opportunity.clients.map(data => ({ value: data, id: data }))
      opportunity.otherClients = opportunity.potentialClients.map(data => ({ value: `${data} (Potential client)`, id: data }))
      opportunity.positionDate = !opportunity.positionStartDate && !opportunity.positionEndDate ? [] : [opportunity.positionStartDate, opportunity.positionEndDate]
      opportunity.primaryContacts = opportunity.primaryContacts.map(user => userFormField(user))
      opportunity.capabilities = opportunity.capabilities.map(data => ({ value: data, id: data }))
      opportunity.author = userFormField(opportunity.author)
      opportunity.percentage = opportunity.numberOfHours ? opportunity.numberOfHours.toString() : null
      opportunity.roleNeeded = opportunity.roleNeeded.map(data => ({ value: data, id: data }))
      return opportunity
    }

    /**
     * @description Stablish webSocket connection
     */
    function setUpWebSocket () {
      webSocketConnection.value = openConnectionWs(`${process.env.VUE_APP_GO_SERVICE_URL}notificationshub?item_id=${store.state.opportunities.opportunityItem.id}`)
      startConnection(webSocketConnection.value)
      webSocketConnection.value.on(
        'notify',
        (message) => {
          if (message.notificationType.toLowerCase() === 'takeover') {
            displaySuccessModal('cantAccess')
            stopWebSocket()
          }
        }
      )
    }

    /**
     * @description Stop webSocket connection
     */
    function stopWebSocket () {
      webSocketConnection.value.stop()
    }

    /**
     * @description Check if potential client enter by user already exists
     */
    function checkClientValue () {
      if (formFields.value.otherClients.length) invalidClients.value = getInvalidClients()
    }

    /**
     * @description Save opportunity information as a draft
     */
    function saveAsDraft () {
      setShowErrors(false)
      if (prePublishValidation(true)) {
        if (formFields.value.status !== 'Closed') {
          formFields.value.startDate = null
          formFields.value.endDate = null
        }
        showDraftSpinner.value = true
        store.dispatch({
          type: 'opportunities/saveAsDraftOpportunity',
          data: generateOpportunityBody()
        }).then(response => {
          showDraftSpinner.value = false
          if (response) postSaveAsDraft(response)
          else displayToastMessage('requestError')
        }).catch(() => {
          showDraftSpinner.value = false
          displayToastMessage('requestError')
        })
      }
    }

    /**
     * @description Actions done after save as draft
     * @param response Endpoint response
     */
    function postSaveAsDraft (response) {
      if (response.id) {
        manageBeforeUnloadListener(false)
        isFormTouched.value = false
        store.commit({
          type: 'opportunities/SET_OPPORTUNITY_ITEM',
          opportunity: { ...store.state.opportunities.opportunityItem, id: response.id }
        })
        formFields.value.status = 'Draft'
        displayToastMessage('draftSuccess')
      }
    }

    /**
     * @description Checks if primary contacts are valid
     */
    function validateContacts () {
      invalidUsers.value = []
      const users = formFields.value.primaryContacts.map(user => user.email)
      return new Promise((resolve, reject) => {
        if (users.length) {
          store.dispatch({
            type: 'opportunities/validateContacts',
            emails: users
          }).then((response) => {
            invalidUsers.value = getInvalidEmails(users, response)
            if (invalidUsers.value.length) {
              document.getElementById('form_contacts').focus()
              showSpinner.value = false
              setShowErrors(false)
            } else resolve()
          })
        } else resolve()
      })
    }

    /**
     * @description Gets an array of emails that aren't on response
     * @param emailsSent A list of emails sent to service
     * @param response A list of valid users got from service
     */
    function getInvalidEmails (emailsSent, response) {
      return emailsSent.filter(email => {
        return !response.some(responseUser => responseUser.email === email.toLowerCase())
      })
    }

    /**
     * @description Gets an array of potential clients that already exists
     */
    function getInvalidClients () {
      return formFields.value.otherClients.filter(client => {
        return store.state.opportunities.metadata.clients.some(listClient => listClient.value.toLowerCase() === client.value.toLowerCase().trim()) || store.state.opportunities.metadata.potentialClients.some(listClient => listClient.id.toLowerCase() === client.value.toLowerCase().trim())
      }).map(item => item.value)
    }

    return {
      store,
      isFormTouched,
      changeHandler,
      goBackHandler,
      goBack,
      exitModalRef,
      successModalRef,
      displaySuccessModal,
      dateLowerLimit,
      publish,
      isMobileResolution,
      loadPage,
      formFields,
      showSpinner,
      searchPeople,
      isAnEdition,
      htmlInputRef,
      isOtherClient,
      isScheduledDate,
      endDateError,
      modalMessage,
      checkClientValue,
      showDraftSpinner,
      showSaveAsDraft,
      saveAsDraft,
      draftError,
      invalidUsers,
      invalidClients,
      inputNumberRef
    }
  }
}
</script>
